import { useEffect, useState } from "react";
import "./components/Main/Darkmode.css";
import "./components/Main/Network.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
import MainPage from "./components/MainPage/MainPage";
import AddSimple from "./components/Products/subpages/add/AddSimple";
import AddVariation from "./components/Products/subpages/add/AddVariation";
import EditPage from "./components/Products/subpages/edit/EditPage";
import Orders from "./components/Orders/Orders";
import ViewOrder from "./components/Orders/ViewOrder";
import Login from "./components/Login/Login";
import NotFound from "./components/NotFound/NotFound";
import Products from "./components/Products/Products";
import WarehouseSettings from "./components/GeneralSettings/Warehouse/WarehouseSettings";
import GeneralSettings from "./components/GeneralSettings/GeneralSettings";
import Giftcards from "./components/GeneralSettings/Giftcards/Giftcards";
import Users from "./components/GeneralSettings/Users/Users";
import EditUsers from "./components/GeneralSettings/Users/EditUsers/EditUsers";
import { ToastContainer } from "react-toastify";
import AddUsers from "./components/GeneralSettings/Users/AddUsers/AddUser";
import ProccessOrders from "./components/Orders/ProccessOrders";
import Customer from "./components/Customer/Customer";
import EditCustomers from "./components/Customer/EditCustomers/EditCustomers";
import ForgotPassword from "./components/Login/pages/ForgotPassword";
import ResetPassword from "./components/Login/pages/ResetPassword";
import NetworkEventListener from "./components/Events/NetworkEventListener";
import UnauthorizedEventListener from "./components/Events/UnauthorizedEventListener";
import ImportExportHome from "./components/Import/importExportHome";
import ExportPage from "./components/Import/exportPage";
import ExportInfoPage from "./components/Import/exportInfoPage";
import ImportPage from "./components/Import/importPage";
import ColumnConfigration from "./components/Import/columnConfigurationPage";
import Results from "./components/Import/resultPage";
import middleware from "./components/Api/Middleware";
import NoAccesScreen from "./components/LoadingScreen/NoAccesScreen";
import LoadingScreen from "./components/LoadingScreen/LoadingScreen";
import ShowProfile from "./components/GeneralSettings/Profile/ShowProfile";
import EditProfile from "./components/GeneralSettings/Profile/EditProfile";
import CancelOrder from "./components/Orders/CancelOrder";
import HouseStyleShowCase from "./components/HouseStyle/HouseStyleShowCase";
import BackofficeRedirectCheck from "./components/CompanyConfig/Components/BackofficeRedirectCheck";
import CompanyInfo from "./components/GeneralSettings/CompanyInfo/CompanyInfo";
import GeneralInfo from "./components/GeneralSettings/CompanyInfo/EditPages/GeneralInfo";
import HouseStyle from "./components/GeneralSettings/CompanyInfo/EditPages/HouseStyle";
import FacturizationDetails from "./components/GeneralSettings/CompanyInfo/EditPages/FacturizationDetails";
import Policies from "./components/GeneralSettings/CompanyInfo/EditPages/Policies";
import TechnicalSettings from "./components/GeneralSettings/TechnicalSettings/TechnicalSettings";
import TechnicalSettingsEdit from "./components/GeneralSettings/TechnicalSettings/TechnicalSettingsEdit";
import ValidationPage from "./components/Import/validationPage";
import VATSettings from "./components/GeneralSettings/VATSettings/VATSettings";
import CompanyConfig from "./components/CompanyConfig/CompanyConfig";
import AppStore from "./components/AppStore/AppStore";
import OrderForm from "./components/Orders/OrderForm";
import ColorSettings from "./components/GeneralSettings/Warehouse/Colors/ColorSettings";
import CategorySettings from "./components/GeneralSettings/Warehouse/Categories/CategorySettings";
import EditCategorySetting from "./components/GeneralSettings/Warehouse/Categories/EditCategorySetting";
import AddCategorySetting from "./components/GeneralSettings/Warehouse/Categories/AddCategorySetting";
import BrandSettings from "./components/GeneralSettings/Warehouse/Brands/BrandSettings";
import BlueprintSettings from "./components/GeneralSettings/Warehouse/Blueprints/BlueprintSettings";
import EditBlueprintSetting from "./components/GeneralSettings/Warehouse/Blueprints/EditBlueprintSetting";
import SizeSettings from "./components/GeneralSettings/Warehouse/Sizes/SizeSettings";
import LabelSettings from "./components/GeneralSettings/Warehouse/Labels/LabelSettings";
import GiftcardOrders from "./components/GeneralSettings/Giftcards/GiftcardOrders";

function AppContent() {
  const location = useLocation();
  const cookies = new Cookies();
  const [csvData, setCsvData] = useState([]);
  const [downloadfiles, setDownloadFiles] = useState([]);
  const [selectedTable, setSelectedTable] = useState("");
  const [importResponse, setImportResponse] = useState(() => {
    const saved = localStorage.getItem("importResponse");
    return saved ? JSON.parse(saved) : [];
  });
  const [navInfo, setNavInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const token = cookies.get("token");
      if (!token) {
        setNavInfo(null);
        window.dispatchEvent(new CustomEvent('unauthorized-event'));
        return;
      }

      // Remove old navInfos with an expired token from the localstorage.
      const cleanupNavInfo = () => {
        const currentToken = token;
        const keysToRemove = [];

        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          if (key && key.startsWith("navInfo[") && key.endsWith("]")) {
            const storedToken = key.slice("navInfo[".length, -1);
            if (storedToken !== currentToken) {
              keysToRemove.push(key);
            }
          }
        }

        keysToRemove.forEach((key) => localStorage.removeItem(key));
      };

      cleanupNavInfo();

      if (!navInfo || navInfo == undefined || navInfo == null) {
        try {
          setLoading(true);
          const response = await middleware.get("navInfo");
          const data = response.data;
          localStorage.setItem(`navInfo[${token}]`, JSON.stringify(data));
          setNavInfo(data);
        } catch (error) {
          console.error("Error fetching navigation details:", error);
          setNavInfo(null);
        } finally {
          setLoading(false);
        }
      }
    }

    fetchData();
  }, [location.pathname]);

  return (
    <>
      <NetworkEventListener />
      <UnauthorizedEventListener />
      <ToastContainer />
      <BackofficeRedirectCheck navInfo={navInfo} loading={loading} />
      <Routes>
        <Route path="/" element={<MainPage />}></Route>
        <Route path="/HouseStyleShowCase" element={<HouseStyleShowCase />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/bedrijfsconfiguratie" element={<CompanyConfig />}></Route>
        <Route path="/wachtwoord-vergeten" element={<ForgotPassword />}></Route>
        <Route path="/wachtwoord-resetten" element={<ResetPassword />}></Route>
        <Route path="/appstore" element={<AppStore />}></Route>
        <Route path="/appstore/:app_slug/*" element={<AppStore />}></Route>
        <Route path="/klanten" element={<Customer />}></Route>
        <Route path="/klanten/bewerken/:internal_id" element={<EditCustomers />}></Route>
        <Route path="/producten" element={<Products />}></Route>
        <Route path="/producten/alles" element={<Products />}></Route>
        <Route path="/producten/nieuw" element={<AddSimple />}></Route>
        <Route path="/producten/nieuw/variatie" element={<AddVariation />}></Route>
        <Route path="/producten/bewerken/:product_id" element={<EditPage />}></Route>
        <Route path="/algemene/instellingen" element={!loading ? (navInfo?.role >= 4 ? <GeneralSettings /> : <NoAccesScreen />) : <LoadingScreen />}></Route>
        <Route path="/algemene/instellingen/bedrijfsinformatie" element={!loading ? (navInfo?.role >= 4 ? <CompanyInfo /> : <NoAccesScreen />) : <LoadingScreen />}></Route>
        <Route path="/algemene/instellingen/bedrijfsinformatie/algemeen" element={!loading ? (navInfo?.role >= 4 ? <GeneralInfo /> : <NoAccesScreen />) : <LoadingScreen />}></Route>
        <Route path="/algemene/instellingen/bedrijfsinformatie/huisstijl" element={!loading ? (navInfo?.role >= 4 ? <HouseStyle /> : <NoAccesScreen />) : <LoadingScreen />}></Route>
        <Route path="/algemene/instellingen/bedrijfsinformatie/facturatie" element={!loading ? (navInfo?.role >= 4 ? <FacturizationDetails /> : <NoAccesScreen />) : <LoadingScreen />}></Route>
        <Route path="/algemene/instellingen/bedrijfsinformatie/voorwaarden" element={!loading ? (navInfo?.role >= 4 ? <Policies /> : <NoAccesScreen />) : <LoadingScreen />}></Route>
        <Route path="/algemene/instellingen/technisch" element={!loading ? (navInfo?.role >= 4 ? <TechnicalSettings /> : <NoAccesScreen />) : <LoadingScreen />}></Route>
        <Route path="/algemene/instellingen/technischBewerken" element={!loading ? (navInfo?.role >= 4 ? <TechnicalSettingsEdit /> : <NoAccesScreen />) : <LoadingScreen />}></Route>
        <Route path="/algemene/instellingen/gebruikers" element={!loading ? (navInfo?.role >= 4 ? <Users /> : <NoAccesScreen />) : <LoadingScreen />}></Route>
        <Route path="/algemene/instellingen/gebruikers/aanmaken" element={!loading ? (navInfo?.role >= 4 ? <AddUsers /> : <NoAccesScreen />) : <LoadingScreen />}></Route>
        <Route path="/algemene/instellingen/gebruikers/bewerken/:user_id" element={!loading ? (navInfo?.role >= 4 ? <EditUsers /> : <NoAccesScreen />) : <LoadingScreen />}></Route>
        <Route path="/algemene/instellingen/btw" element={!loading ? (navInfo?.role >= 4 ? <VATSettings /> : <NoAccesScreen />) : <LoadingScreen />}></Route>
        <Route path="/algemene/instellingen/cadeaukaarten" element={!loading ? (navInfo?.role >= 4 ? <Giftcards /> : <NoAccesScreen />) : <LoadingScreen />}></Route>
        <Route path="/algemene/instellingen/cadeaukaarten/mutaties" element={!loading ? (navInfo?.role >= 4 ? <GiftcardOrders /> : <NoAccesScreen />) : <LoadingScreen />} />
        <Route path="/algemene/instellingen/product" element={<WarehouseSettings />}></Route>
        <Route path="/algemene/instellingen/product/kleuren" element={<ColorSettings />}></Route>
        <Route path="/algemene/instellingen/product/blauwdrukken" element={<BlueprintSettings />}></Route>
        <Route path="/algemene/instellingen/product/blauwdrukken/bewerken" element={<EditBlueprintSetting />}></Route>
        <Route path="/algemene/instellingen/product/merken" element={<BrandSettings />}></Route>
        <Route path="/algemene/instellingen/product/maten" element={<SizeSettings />}></Route>
        <Route path="/algemene/instellingen/product/categorieën" element={<CategorySettings />}></Route>
        <Route path="/algemene/instellingen/product/categorieën/bewerken/:category_id" element={<EditCategorySetting />}></Route>
        <Route path="/algemene/instellingen/product/categorieën/toevoegen" element={<AddCategorySetting />}></Route>
        <Route path="/algemene/instellingen/product/labels" element={<LabelSettings />}></Route>
        <Route path="/profiel" element={!loading ? <ShowProfile /> : <LoadingScreen />}></Route>
        <Route path="/profiel/bewerken" element={!loading ? <EditProfile /> : <LoadingScreen />}></Route>
        <Route path="/bestellingen" element={<Orders />}></Route>
        <Route path="/bestellingen/nieuw" element={<OrderForm />}></Route>
        <Route path="/bestellingen/overzicht/:order_number" element={<ViewOrder />}></Route>
        <Route path="/bestellingen/bewerken/:order_number" element={<OrderForm />}></Route>
        <Route path="/bestellingen/annuleren/:order_number" element={<CancelOrder />}></Route>
        <Route path="/bestellingen/verwerken/:order_number" element={<ProccessOrders />}></Route>
        <Route path="/import-export-center" element={<ImportExportHome />}></Route>
        <Route path="/export" element={<ExportPage />}></Route>
        <Route path="/export/resultaat/:export_id" element={<ExportInfoPage />}></Route>
        <Route path="/import" element={<ImportPage setCsvData={setCsvData} setDownloadFiles={setDownloadFiles} setSelectedTable={setSelectedTable} selectedTable={selectedTable} />}></Route>
        <Route path="/import/kolom-configuratie" element={<ColumnConfigration csvData={csvData} downloadfiles={downloadfiles} selectedTable={selectedTable} importResponse={importResponse} setImportResponse={setImportResponse} />}></Route>
        <Route path="/import/resultaat/:import_id" element={<Results />}></Route>
        <Route path="/import/valideren/:import_id" element={<ValidationPage />}></Route>
        <Route path="/*" element={<NotFound />}></Route>
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter future={{
      v7_relativeSplatPath: true,
      v7_startTransition: true,
    }}>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
